"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Wrapper = exports.baseStyles = exports.CONFIG = exports.SIZES = void 0;
var styled_components_1 = __importStar(require("styled-components"));
var media_1 = require("../../../theme/media");
var theme_1 = require("../../../theme");
exports.SIZES = {
    1: {
        fontSize: '18px',
        lineHeight: '26px',
    },
    2: {
        fontSize: '16px',
        lineHeight: '22px',
    },
    3: {
        fontSize: '14px',
        lineHeight: '18px',
    },
};
exports.CONFIG = {
    1: {
        large: exports.SIZES[1],
        medium: exports.SIZES[2],
        small: exports.SIZES[3],
    },
    2: {
        large: exports.SIZES[2],
        medium: exports.SIZES[3],
        small: exports.SIZES[3],
    },
    3: {
        large: exports.SIZES[3],
        medium: exports.SIZES[3],
        small: exports.SIZES[3],
    },
};
exports.baseStyles = (0, styled_components_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  font-family: 'IBM Plex Mono', monospace;\n  font-weight: normal;\n\n  font-size: ", ";\n  line-height: ", ";\n\n  @media ", " {\n    font-size: ", ";\n    line-height: ", ";\n  }\n\n  @media ", " {\n    font-size: ", ";\n    line-height: ", ";\n  }\n"], ["\n  font-family: 'IBM Plex Mono', monospace;\n  font-weight: normal;\n\n  font-size: ", ";\n  line-height: ", ";\n\n  @media ", " {\n    font-size: ", ";\n    line-height: ", ";\n  }\n\n  @media ", " {\n    font-size: ", ";\n    line-height: ", ";\n  }\n"])), function (_a) {
    var _b = _a.$level, $level = _b === void 0 ? '1' : _b;
    return exports.CONFIG[$level].small.fontSize;
}, function (_a) {
    var _b = _a.$level, $level = _b === void 0 ? '1' : _b;
    return exports.CONFIG[$level].small.lineHeight;
}, media_1.breakpoints.medium, function (_a) {
    var _b = _a.$level, $level = _b === void 0 ? '1' : _b;
    return exports.CONFIG[$level].medium.fontSize;
}, function (_a) {
    var _b = _a.$level, $level = _b === void 0 ? '1' : _b;
    return exports.CONFIG[$level].medium.lineHeight;
}, media_1.breakpoints.large, function (_a) {
    var _b = _a.$level, $level = _b === void 0 ? '1' : _b;
    return exports.CONFIG[$level].large.fontSize;
}, function (_a) {
    var _b = _a.$level, $level = _b === void 0 ? '1' : _b;
    return exports.CONFIG[$level].large.lineHeight;
});
exports.Wrapper = styled_components_1.default.p.attrs(function (_a) {
    var as = _a.as, $inline = _a.$inline;
    return ({
        as: as || ($inline ? 'span' : 'p'),
    });
})(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  ", "\n  color: ", ";\n\n  margin: 0 0 ", "em 0;\n  padding: 0;\n  max-width: ", ";\n\n  &:last-child {\n    margin-bottom: 0;\n  }\n"], ["\n  ", "\n  color: ", ";\n\n  margin: 0 0 ", "em 0;\n  padding: 0;\n  max-width: ", ";\n\n  &:last-child {\n    margin-bottom: 0;\n  }\n"])), exports.baseStyles, function (_a) {
    var $color = _a.$color;
    return ($color ? theme_1.theme.colors[$color] : 'currentColor');
}, function (_a) {
    var $inline = _a.$inline;
    return ($inline ? 0 : 1);
}, function (_a) {
    var $maxWidth = _a.$maxWidth;
    return ($maxWidth ? "".concat($maxWidth, "em") : '');
});
var templateObject_1, templateObject_2;
